import { offRouteTitle } from "./routePlan";

/** Rule V-10: the mark of a stop outside the home areas of the truck. */
export function OffRouteMark({ truck }: { truck: string }) {
  const title = offRouteTitle(truck);
  return (
    <span className="chip-flag off-route" data-testid="off-route" title={title} aria-label={title}>
      Off route
    </span>
  );
}
